import { useEffect, useState } from 'react';
// import "./joinRoom.css";
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import toast from 'react-hot-toast';
import { db } from '../config/firebaseConfig';
import { UserAuth } from '../context/authContext';

const JoinRoom = () => {
  const [roomId, setRoomId] = useState(localStorage.getItem('roomId') || '');
  const [roomType, setRoomType] = useState('');
  const { userData } = UserAuth();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!roomId) return;
    setIsLoading(true);

    const unsubscribe = db
      .collection('rooms')
      .doc(roomId)
      .onSnapshot(
        (roomSnapshot) => {
          if (roomSnapshot.exists) {
            const data = roomSnapshot.data();
            setRoomType(data.roomType); // Set the room type from Firestore
            setIsLoading(false);
          } else {
            setRoomType('');
            toast.error('Room ID is invalid or does not exist.');
            localStorage.removeItem('roomId');
            window.location.reload();
            setIsLoading(false);
          }
        },
        (error) => {
          console.error('Error fetching room details:', error);
          toast.error('Error fetching room details.');
          localStorage.removeItem('roomId');
          window.location.reload();
          setIsLoading(false);
        }
      );

    return () => unsubscribe();
  }, [roomId]);
  // Join room logic
  const handleJoinRoom = async () => {
    if (!roomId) {
      toast.error('Please enter a room ID.');
      return;
    }

    setIsLoading(true);
    try {
      const roomRef = db.collection('rooms').doc(roomId);
      const roomSnapshot = await roomRef.get();

      if (!roomSnapshot.exists) {
        toast.error('Room not found. Please enter a valid room ID.');
        localStorage.removeItem('roomId');
        window.location.reload();
        setIsLoading(false);
        return;
      }

      const roomData = roomSnapshot.data();
      const isAstraPos = roomData.roomType === 'ASTRAPOS';

      // Check if user is already a miner or participant
      const isMiner = roomData.miners?.includes(userData.publicKey);
      const isParticipant = roomData.participants?.includes(userData.publicKey);

      // Determine the role to use
      let userRole = 'participant';
      const batch = db.batch();

      // Only add to arrays if not already present
      if (isMiner) {
        // User is already a miner, don't change anything
        userRole = 'validator';
      } else if (!isParticipant) {
        // User is not in either array, add as participant
        batch.update(roomRef, {
          participants: firebase.firestore.FieldValue.arrayUnion(
            userData.publicKey
          ),
        });
      }

      localStorage.setItem('roomId', roomId);
      localStorage.setItem('role', userRole);

      // Commit the batch write to Firestore only if there are changes
      if (!isMiner && !isParticipant) {
        await batch.commit();
      }

      toast.success('Room joined successfully');

      // Redirect to game
      window.location.href = isAstraPos ? '/game' : '/joinedroom';
    } catch (error) {
      console.error('Error joining room:', error);
      toast.error('Failed to join room. Please try again later.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="max-w-xl mx-auto p-6  rounded-lg shadow-md">
      <div className="mb-4">
        <label
          htmlFor="roomId"
          className="block text-2xl text-white font-semibold mb-2"
        >
          Room ID
        </label>
        <input
          type="text"
          id="roomId"
          placeholder="Enter Room ID"
          value={roomId}
          onChange={(e) => {
            e.preventDefault();
            setRoomId(e.target.value);
          }}
          className="form-control "
          disabled={isLoading}
        />
      </div>
      <button
        onClick={handleJoinRoom}
        disabled={isLoading || !roomId}
        className={`btn btn-primary font-semibold px-4 py-2 rounded-full ${
          isLoading || !roomId ? 'opacity-50 cursor-not-allowed' : ''
        }`}
      >
        Join Room
      </button>
    </div>
  );
};

export default JoinRoom;
